import React from 'react'
import logo from '../../assets/logo.png'
import {FiSearch} from 'react-icons/fi'
import {AiOutlineHeart} from 'react-icons/ai'
import {BsHandbag} from 'react-icons/bs'
import {FaUserCircle, FaBars} from 'react-icons/fa'
import {Link} from 'react-router-dom'
import {CartState} from '../../context/Context'
import Line from './Line'


const Header = () => {
  const {state: {cart,favourite}, dispatch} = CartState();
  const cartCount = cart.length;
  const favCount = favourite.length;

  return (
    <div className="sticky top-0 z-50 bg-white flex items-center px-4 py-4 lg:py-0 lg:px-8 shadow-md justify-between font-poppins text-base  ">
        
        {/* Left */}
        <div className="flex items-center">
            <FaBars className="lg:hidden icon mr-4" 
            style={{fontSize:'1.75rem'}}
            />
            <Link to="/" className="flex items-center">
            <img src={logo}  
            className="w-auto cursor-pointer mr-4 h-fit"
            />
            </Link>
          
        </div>

        {/* center */}
        <div className=" hidden relative lg:flex justify-between border-l-2 border-r-2 h-12 border-ash   flex-grow">
       
         
        <div className=" hidden  md:flex md:align-center mt-4 ml-2 space-x-6 md:space-x-10">
        <Link to="/" className="font-poppins font-medium  text-base "      >
            Home
        </Link>
        <Link to="/all-products" className="font-poppins font-medium  text-base "  >
            All Products
        </Link>
        <Link to="/collection" className="font-poppins font-medium  text-base "      >
            Collections
        </Link>
        </div>
            {/* Search Session */}
              <div className="hidden md:flex ml-2 items-center  px-2">
                <FiSearch className="h-6 text-ash" />
                <input type="text" placeholder="Seach for products...."
                className="flex ml-2   md:inline-flex items-center bg-transparent outline-none  flex-shrink placeholder-ash font-light"
                />
            </div>
         
        </div>

        {/* Right */}
        <div className="flex items-center ml-2 sm:spacing-x-2 justify-end ">
           {/* Profile pic */}
          
           <Link to="/fav" className="relative" >
           {/* <p className="absolute hidden md:block text-sm text-white rounded-full px-2  font-bold top-0 right-0 left-4 mr-4 bg-orange">
             {favCount}</p> */}
           <AiOutlineHeart className=" hidden md:block icon  "
           style={{fontSize:'1.5rem'}}
           />

           </Link>

           <Link to="/cart" className="relative " >
             {/* <p className="absolute text-sm text-white rounded-full px-2  font-bold top-0 right-0 left-4 mr-4 bg-tradr-green">
             {cartCount}</p> */}
           <BsHandbag
                className="icon  " 
                style={{fontSize:'1.5rem'}}
                />
              </Link>
              <Link to="/login" className="relative " >
           <FaUserCircle className="icon "
            style={{fontSize:'1.5rem'}}
           />
          </Link>
        </div>
      </div>
  )
}

export default Header

